import { GetActivePlayerData } from '@/modules/manage-player/type'
import { columns } from '../ActivePlayerTable/constants'
import { DataTableArrow } from '@/common/ui/table/data-table-arrow'
import { Card } from '@/common/ui/card'
import { Separator } from '@/common/ui/separator'
import { DateRangePicker } from '@/common/components/DateRangePicker'
import DateRangeButtons from '@/common/components/DateRangeButtons'
import { Button } from '@/common/ui/button'
import { ArrowLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import Heading from '@/common/shared/heading'
import PlayerSearchControls from '@/common/components/PlayerSearchControls'

interface ActivePlayerListingProps {
	data: GetActivePlayerData[]
	total: number
	isLoading?: boolean
	onSort?: (columnId: string, order: 'asc' | 'desc' | undefined) => void
	showBackButton?: boolean
}

export default function ActivePlayerListing({
	data,
	total,
	isLoading,
	onSort,
	showBackButton = true,
}: ActivePlayerListingProps) {
	const navigate = useNavigate()

	return (
		<Card>
			<div className="space-y-4 p-3 sm:p-4">
				{showBackButton && (
					<Button
						onClick={() => navigate(-1)}
						variant="outline"
						size="sm"
						className="mb-4 flex items-center gap-2"
					>
						<ArrowLeft className="h-4 w-4" />
						ย้อนกลับ
					</Button>
				)}

				{/* Header Section - Mobile Responsive */}
				<div className="space-y-4">
					{/* Title and Date Controls Row */}
					<div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
						{/* Title */}
						<Heading
							title="ผู้เล่นที่มียอดเดิมพัน"
							description={`รายการผู้เล่นที่มียอดเดิมพันทั้งหมด ${total} รายการ`}
						/>

						{/* Date Controls */}
						<div className="flex flex-col gap-3 sm:items-end">
							<DateRangePicker />
							<DateRangeButtons />
						</div>
					</div>

					{/* Search Controls */}
					<PlayerSearchControls />
				</div>

				<Separator className="my-4 sm:my-6" />

				{/* Table Section */}
				<div className="space-y-4">
					<DataTableArrow
						columns={columns}
						data={data}
						total={total}
						isLoading={isLoading}
						onSort={onSort}
					/>
				</div>
			</div>
		</Card>
	)
}
